
















































































import { Inject } from '@cds/common';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { BonusService } from '@/services/bonus-service';
import bonuseUpload from './compoennts/bonuseUpload.vue';

@Component({
  components: {
    bonuseUpload
  }
})
export default class wechatImageText extends Vue {
  public form: any = {
    size: 10,
    current: 1,
    total: 0
  };
  public formInfo :any = {
    type:'0'
  };
  public labelPosition: String = 'top';
  public title:string ='';
  public dialogVisible: boolean = false;
  public tableData: any[] = [];
  public position: any[] = [];
  public loading: Boolean = true;
  public kindshow: Boolean = false;
  private currentRow: any = null;
  public rules: any = {
          mail: [
             { required: true, message: '请输入邮箱', trigger: ['change','blur'] }],
          position: [
            { required: true, message: '请选择职位', trigger: ['change','blur']}],
          positionUserId: [
             { required: true, message: '请输入用户id', trigger: ['change','blur'] }],
  }
  @Inject(BonusService) private bonusService!: BonusService;

  public async created(): Promise<void> {
    await this.getList();
    this.positionList();
  }

  public search() {
    this.form.current = 1;
    this.getList()
  }
  //新增
  public async handAdd(){
    this.title = '新增管理员模拟配置'
    this.formInfo = {};
    this.dialogVisible = true;
  }
  //修改
  public async handUpdate(row: any){
    this.title = '修改管理员模拟配置'
    this.formInfo = row;
    this.dialogVisible = true;
  }
  //保存
  public submitForm() : void{
      const addRef = (this.$refs.formInfo as any)
      addRef.validate( async (valid: any) => {
          if (valid) {
            if(this.formInfo.id == undefined){
              const res = await this.bonusService.addAdminImpersonation(this.formInfo);
              this.$message({
                message: '添加成功',
                type: 'success'
              });
            }else{
              const res = await this.bonusService.updateAdminImpersonation(this.formInfo);
              this.$message({
                message: '修改成功',
                type: 'success'
              });
            }
            this.dialogVisible = false;
            this.getList();
          } else {
            console.log('error submit!!');
            return false;
          }
      });
  }
  //职位
  public async positionList(): Promise<void> {
    const res = await this.bonusService.position();
    this.position = res
  }
  //分页相关
  public handleSizeChange(size: number) {
    this.form.size = size;
    this.getList();
  }
  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getList();
  }
  //获取数据源
  public async getList() {
    this.loading = true;
    const res = await this.bonusService.adminImpersonationList(this.form);
    this.loading = false;
    let data: any = res.records
    this.tableData = data
    this.form.total = res.total;
    this.form.size = res.size;
    this.form.current = res.current;
  }
    //下载
    public async downLoadAll() {
    this.loading = true;
    var data_ = {
      type:'13'
    }
    const res = await this.bonusService.downLoadAll(data_,'管理员模拟权限配置.xlsx');
    this.loading = false;
  }

  // 重置
  public reset() {
    this.form = {
      size: 10,
      current: 1,
      total: 0
    };
    this.search()
  }

}
